import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { StreamingShowcase } from "@/components/StreamingShowcase";
import "./index.css";

import logo from "./logo.svg";
import reactLogo from "./react.svg";

export function App() {
  return (
    <div className="container mx-auto p-8 text-center relative z-10">
      <div className="flex justify-center items-center gap-8 mb-8">
        <img
          src={logo}
          alt="Bun Logo"
          className="h-36 p-6 transition-all duration-300 hover:drop-shadow-[0_0_2em_#646cffaa] scale-120"
        />
        <img
          src={reactLogo}
          alt="React Logo"
          className="h-36 p-6 transition-all duration-300 hover:drop-shadow-[0_0_2em_#61dafbaa] [animation:spin_20s_linear_infinite]"
        />
      </div>
      <Card className="border border-border/60 shadow-2xl shadow-primary/10">
        <CardHeader className="gap-4">
          <CardTitle className="text-3xl font-bold tracking-wide">流式 VS 非流式输出实验台</CardTitle>
          <CardDescription className="text-base">
            配置期望的总耗时，观察 Bun 后端如何自动拆分 chunk，并通过 React 实时展示流式与非流式输出的差异。
          </CardDescription>
        </CardHeader>
        <CardContent>
          <StreamingShowcase />
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
